import { render } from "./LobbyView.vue?vue&type=template&id=6c86417d&scoped=true"
import script from "./LobbyView.vue?vue&type=script&lang=js"
export * from "./LobbyView.vue?vue&type=script&lang=js"

import "./LobbyView.vue?vue&type=style&index=0&id=6c86417d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c86417d"]])

export default __exports__